import classNames from 'classnames';
import React, { memo } from 'react';

import { useIsMobile } from '@sravni/react-utils';

import { PartnerLabel } from '../../MaterialContent/components/ArticleHeader/partnerLabel';
import { Card } from '../Card';
import { IListsCardProps } from '../types';

import styles from './styles.module.scss';

export const OrgMaterialCard = memo<IListsCardProps>(({ material, index, size, color, direction = 'vertical' }) => {
  const { alias, commentsCount, likes, publishDate, pubDate, title, organizationData, visits } = material;

  const isMobile = useIsMobile();
  return (
    <Card className={styles[`card__direction-${direction}`]} direction={direction} size={size} color={color}>
      <Card.Content className={styles.content}>
        <Card.Row>
          {organizationData && <PartnerLabel className={styles.partnerLabel} organizationData={organizationData} />}
        </Card.Row>
        <Card.Row>
          <Card.Title
            id={alias}
            as={index === 0 ? 'h1' : 'h2'}
            className={classNames(styles.title, styles[`title_size-${size}`])}
          >
            {title}
          </Card.Title>
        </Card.Row>
        <Card.DescriptionRow
          date={publishDate || pubDate}
          comments={commentsCount}
          likes={likes}
          justify={isMobile ? 'start' : 'space-between'}
          className={styles.descriptionRow}
          visits={visits}
        />
      </Card.Content>
    </Card>
  );
});
